import React from 'react'
import { Grid, Column, actionCell, iconCell, enumCell, dateCell, createEnumFilterCell } from 'components/grid'
import { localized } from 'decorators'
import { orderStatus } from 'enums/orderStatus'
import { paymentType } from 'enums/paymentType'
import { history } from 'store/modules'
import { urls } from 'urls'
import { formatDate } from 'utils/dateUtilities'

const additionalButtons = [
  {
    icon: 'newspaper-o',
    tooltip: 'orders.processOrder',
    isDisabled: (dataItem) => dataItem.status === 0,
    onClick: (dataItem) => history.push(`${urls.orderProcessing.base}/${dataItem.id}`)
  }
]
export default localized(({ dataSource, metadata, onRowClick, localize, actionProps, persistor, isTrash }) => {
  const actionCellProps = {
    actionProps,
    nameGetter: x => `${x.supplierName} (${formatDate(x.dateOfOrder)})`,
    additionalButtons: isTrash ? null : additionalButtons,
    isSoftDelete: metadata.isSoftDelete
  }
  return (
    <Grid
        dataSource={dataSource}
        onRowClick={onRowClick}
        persistor={persistor}
        dateProperties={['dateOfOrder']}>
        <Column field='id' title={localize('common.id')} width='70px' filterable={false} />
        <Column field='supplierName' title={localize('orders.supplier')} cell={iconCell({ icon: metadata.icon })} width='250px' />
        <Column field='dateOfOrder' title={localize('orders.dateOfOrder')} filter='date' cell={dateCell()} width='250px' />
        <Column field='totalUnits' title={localize('orders.totalUnits')} filter='numeric' width='200px' />
        <Column field='status' title={localize('orders.status')} cell={enumCell({ enum: orderStatus })} filterCell={createEnumFilterCell({ enum: orderStatus, width: 210 })} width='230px' />
        <Column field='dateOfPayment' title={localize('orders.dateOfPayment')} filter='date' cell={dateCell()} width='250px' />
        <Column field='paymentType' title={localize('orders.paymentType')} cell={enumCell({ enum: paymentType })} filterCell={createEnumFilterCell({ enum: paymentType, width: 210 })} width='230px' />
        <Column cell={actionCell(actionCellProps)} width='100px' filterable={false} sortable={false} />
    </Grid>
  )
})